import SearchRoundedIcon from '@mui/icons-material/SearchRounded'
import { Chip, Stack, Typography } from '@mui/material'

import { color } from '@/v2/design-system/tokens'

/**
 * Prototipo VISUAL únicamente (pedido explícito de Fase 1) — la barra de
 * comandos real (Ctrl+K, navegación, búsqueda) es Fase 2 y debe reutilizar
 * `components/common/GlobalSearch.tsx` ya existente, nunca duplicar su
 * lógica. Este componente no ejecuta ninguna búsqueda ni abre nada.
 */
export function CommandInput({ placeholder = 'Buscar o preguntar a GOVIA…' }: { placeholder?: string }) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1.25}
      sx={{
        px: 2,
        height: 56,
        borderRadius: 2,
        border: `1px solid ${color.borderStrong}`,
        bgcolor: color.surface,
      }}
    >
      <SearchRoundedIcon fontSize="small" sx={{ color: color.muted }} />
      <Typography variant="body2" sx={{ flex: 1, color: color.muted }}>
        {placeholder}
      </Typography>
      <Chip size="small" variant="outlined" label="Ctrl+K" sx={{ height: 22, fontSize: 11 }} />
    </Stack>
  )
}
